<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Attendance User ID"
      text="Update user ID"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="user_id"
                v-validate="'integer|moreThanZero'"
                :error-messages="errors.collect('user_id')"  
                data-vv-name="user_id"
                data-vv-as="user ID used for attendance"
                type="number"
              />
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      userUid: {
        type: String,
        required: true,
      },
      userId: {
        type: Number,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        user_id: null,
        loading: false,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.user_id = this.userId

        this.$validator.extend('moreThanZero', {
          getMessage (field, args) {
            return 'Invalid ID, user ID must be greater than 0'
          },
          validate (value, args) {
            return value > 0
          },
        })

        this.loading = false
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.users().update(this.userUid, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: 'Employee attendance user ID updated' })
                }
                this.dialog = false
              })
              .catch(err => {
                if (err.response.status === 422) {
                  this.$snack({ color: 'error', message: 'Duplicate entry of user ID' })
                  this.$scrollToFirstErrorInput()
                } else {
                  this.$snack({ color: 'error', message: 'Unable to update user ID' })
                }
              })
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          user_id: this.user_id,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background: white;
}
</style>
